import { useState, useCallback } from "react";
import { extractTextFromImage } from "@/lib/ocr";

export interface UseOcrOptions {
  formatCode?: boolean;
  lang?: string;
}

export function useOcr(options: UseOcrOptions = {}) {
  const [isExtracting, setIsExtracting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const extractText = useCallback(
    async (imageDataUrl: string) => {
      setIsExtracting(true);
      setError(null);
      try {
        const result = await extractTextFromImage(imageDataUrl, {
          formatCode: options.formatCode ?? true,
          lang: options.lang ?? "eng",
        });
        return result;
      } catch (e) {
        const message = e instanceof Error ? e.message : "OCR failed";
        setError(message);
        throw e;
      } finally {
        setIsExtracting(false);
      }
    },
    [options.formatCode, options.lang]
  );

  const clearError = useCallback(() => setError(null), []);

  return { extractText, isExtracting, error, clearError };
}
